<template>
  <div v-if="module != null">
    <v-row no-gutters v-for="(mappedStep, idx) in controller.steps" :key="idx">
      <v-col cols="12">
        <h3 class="mt-3">Step {{ mappedStep.rank }}</h3>
      </v-col>
      <addStep v-if="module.canAdd&&!canAddStep" label="add action" :mappedStep="mappedStep" :ctrl="ctrl" icon="add.png" />
      <action v-for="(step, idx) in mappedStep.steps" :ctrl="ctrl" :key="idx" :step="step" :label="step.systemCode"
        :icon="'workflow/' + step.systemCode + '.png'" />
    </v-row>
    <v-divider class="mt-4"></v-divider>

    <div class="text-center py-2">
      <v-btn outlined :disabled="canAddStep" v-if="module.canAdd" color="grey" class="mx-auto" small
        @click="controller.addWorkflowStep()">Add Step</v-btn>
    </div>
  </div>
</template>

<script>
  import action from "./action";
  import addStep from "./addStep";

  export default {
    props: {
      ctrl: String,
    },
    data() {
      return {
        module: null,
        controller: this.get_controller(this.ctrl).sections.workflow_step,
      };
    },
    computed: {
      canAddStep() {
        if(this.module!=null){
          if(this.module.maxSteps==-1){
            return false
          }else{
            if(this.controller.totalSteps+1 < this.module.maxSteps)
            {
              return false
            }else{
              return true
            }
          }
        }else{
          return false
        }
      }
    },
    components: {
      action,
      addStep,
    },
    mounted() {
      this.module = this.systemModules[this.$route.params.systemCode];
      console.log("[MODULE]", this.module);
      this.allowedModules = this.module.getAllowedModules();
    },
  };
</script>